import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const workplace = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/miscellaneous/{profile}/workplace',
    app: 'miscellaneous'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'miscellaneous', model: 'workplace' }
    ),
    { }
  )
)()

export { workplace, TYPES }
